@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.profile.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/mobile_wallet.feature.profile.generated.resources/"

internal val Res.drawable.placeholder: DrawableResource by lazy {
      DrawableResource("drawable:placeholder", setOf(
        ResourceItem(setOf(), "${MD}drawable/placeholder.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("placeholder", Res.drawable.placeholder)
}
